function Three() {
    return (
        <div class="gal">
            <div class="gal_1">
                <img src="/images/walk.jpg" alt="Solo Levelling"></img>
                <h2>Muzan's Walk</h2>
                <p>Muzan makes his Entrance , calm yet Terrifying</p>
                <button>Aura</button>
            </div>
            <div class="gal_1">
                <img src="/images/a.jpg" alt="Naruto"></img>
                <h2>Light Yagami - Kira</h2>
                <p>Laugh of a Mortal being exposed as Kira</p>
                <button>Action</button>
            </div>

            <div class="gal_1">
                <img src="/images/five.jpg" alt="Solo Levelling"></img>
                <h2>Goku vs Lord Beerus</h2>
                <p>Goku fights to save Earth from God of Destruction</p>
                <button>Action</button>

            </div>

            <div class="gal_1">
                <img src="/images/nagi.png" alt="Solo Levelling"></img>
                <h2>Nagi Seishiro</h2>
                <p>Boy having Efffortless Skills scores a Goal</p>
                <button>Action</button>
            </div>

        </div>
    )
}
export default Three;

